<template>
<div class="courseAndQuesDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' title="选择商品" :visible.sync="dialogVisible" width="650px">
        <el-tabs type="card" v-model="activeName" addable @tab-click="handleChange" :class="[activeName=='course'?'course':'ques']">
            <el-tab-pane label="课程" name="course">
                <div class="right_main_box">
                    <div class="search_box">
                        <div class="innerbox">
                        </div>
                        <div class="innerbox">
                            <el-input placeholder="输入课程名称" v-model="course.param.kmcname" clearable></el-input>
                            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
                        </div>
                    </div>
                    <div class="add_goods_tabs_box">
                        <el-table :data="course.tableData" style="width: 100%" :show-header="true"
                                  ref="multipleTable1"
                                  @select="handleSelectionChange" @row-click="handleRowChange"
                                  @select-all="handleAllSelectionChange">
                            <el-table-column type="selection" width="45" :show-overflow-tooltip="false"></el-table-column>
                            <el-table-column label="课程信息">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <div class="left">
                                            <img class="img" v-lazy="scope.row.coverurl" alt>
                                        </div>
                                        <div class="right">
                                            <div class="text-ellipse innerbox">{{scope.row.kmcname}}</div>
                                            <div class="tc-red innerbox">{{scope.row.saleprice=='0.00'?'免费': '￥' + scope.row.saleprice}}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page" style="margin-top: 15px; text-align: center">
                        <el-pagination background @current-change="handleSizeChange" :current-page.sync="course.page.page"  :page-size="course.page.pageSize"
                                       :pager-count="11"  layout="prev, pager, next" :total="course.total"></el-pagination>
                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="handleSure()">确 定</el-button>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="题库" name="ques">
                <div class="right_main_box">
                    <div class="search_box">
                        <div class="innerbox">
                        </div>
                        <div class="innerbox">
                            <el-input placeholder="输入题库名称" v-model="ques.param.kmcname" clearable></el-input>
                            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
                        </div>
                    </div>
                    <div class="add_goods_tabs_box">
                        <el-table :data="ques.tableData" style="width: 100%" ref="multipleTable2"
                                  @select="handleSelectionChange" @row-click="handleRowChange">
                            <el-table-column type="selection" width="45" :show-overflow-tooltip="false"></el-table-column>
                            <el-table-column label="题库信息">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <div class="left">
                                            <img class="img" v-lazy="scope.row.coverurl" alt>
                                        </div>
                                        <div class="right">
                                            <div class="text-ellipse innerbox">{{scope.row.kmcname}}</div>
                                            <div class="tc-red innerbox">{{scope.row.saleprice=='0.00'?'免费': '￥' + scope.row.saleprice}}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page" style="margin-top: 15px; text-align: center">
                        <el-pagination background @current-change="handleSizeChange" :current-page.sync="ques.page.page"  :page-size="ques.page.pageSize"
                                       :pager-count="11"  layout="prev, pager, next" :total="ques.total"></el-pagination>
                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="handleSure()">确 定</el-button>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="报告" name="report">
                <div class="right_main_box">
                    <div class="search_box">
                        <div class="innerbox">
                        </div>
                        <div class="innerbox">
                            <el-input placeholder="输入报告名称" v-model="report.param.kmcname" clearable></el-input>
                            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
                        </div>
                    </div>
                    <div class="add_goods_tabs_box">
                        <el-table :data="report.tableData" style="width: 100%" ref="multipleTable3"
                                  @select="handleSelectionChange" @row-click="handleRowChange">
                            <el-table-column type="selection" width="45" :show-overflow-tooltip="false"></el-table-column>
                            <el-table-column label="报告信息">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <div class="left">
                                            <img class="img" v-lazy="scope.row.coverurl" alt>
                                        </div>
                                        <div class="right">
                                            <div class="text-ellipse innerbox">{{scope.row.kmcname}}</div>
                                            <div class="tc-red innerbox">{{scope.row.saleprice=='0.00'?'免费': '￥' + scope.row.saleprice}}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page" style="margin-top: 15px; text-align: center">
                        <el-pagination background @current-change="handleSizeChange" :current-page.sync="report.page.page"  :page-size="report.page.pageSize"
                            :pager-count="11"  layout="prev, pager, next" :total="report.total"></el-pagination>
                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="handleSure()">确 定</el-button>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="直播" name="live">
                <div class="right_main_box">
                    <div class="search_box">
                        <div class="innerbox">
                        </div>
                        <div class="innerbox">
                            <el-input placeholder="输入直播名称" v-model="live.param.kmcname" clearable></el-input>
                            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
                        </div>
                    </div>
                    <div class="add_goods_tabs_box">
                        <el-table :data="live.tableData" style="width: 100%" ref="multipleTable4"
                                  @select="handleSelectionChange" @row-click="handleRowChange">
                            <el-table-column type="selection" width="45" :show-overflow-tooltip="false"></el-table-column>
                            <el-table-column label="直播信息">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <div class="left">
                                            <img class="img" v-lazy="scope.row.coverurl" alt>
                                        </div>
                                        <div class="right">
                                            <div class="text-ellipse innerbox">{{scope.row.kmcname}}</div>
                                            <div class="tc-red innerbox">{{scope.row.saleprice=='0.00'?'免费': '￥' + scope.row.saleprice}}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page" style="margin-top: 15px; text-align: center">
                        <el-pagination background @current-change="handleSizeChange" :current-page.sync="live.page.page"  :page-size="live.page.pageSize"
                            :pager-count="11"  layout="prev, pager, next" :total="live.total"></el-pagination>
                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="handleSure()">确 定</el-button>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>
</div>
</template>

<script>
import {getAsseCommonformKMCList} from 'api/operateToolApi'
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'courseAndQuesDialog',
    data() {
        return {
            dialogVisible: false,
            activeName: 'course',
            course: {
                param: {
                    kmcname: '',
                    kmctype: 7
                },
                page: {
                    page: 1,
                    pageSize: 20,
                    pageCount: 0
                },
                total: 0,
                tableData: [],
            },
            ques: {
                param: {
                    kmcname: '',
                    kmctype: 8
                },
                page: {
                    page: 1,
                    pageSize: 20,
                    pageCount: 0
                },
                total: 0,
                tableData: [],
            },
            report: {
                param: {
                    kmcname: '',
                    kmctype: 2
                },
                page: {
                    page: 1,
                    pageSize: 20,
                    pageCount: 0
                },
                total: 0,
                tableData: [],
            },
            live: {
                param: {
                    kmcname: '',
                    kmctype: 3
                },
                page: {
                    page: 1,
                    pageSize: 20,
                    pageCount: 0
                },
                total: 0,
                tableData: [],
            },
            selectedResult: [],
        }
    },
    mounted() {
    },
    methods: {
        handleChange() {
            if (this.activeName == 'course') {
                this._getList()
            } else if (this.activeName == 'ques') {
                this._getList2()
            } else if (this.activeName == 'report') {
                this._getList3()
            } else if (this.activeName == 'live') {
                this._getList4()
            }
        },
        handleSizeChange() {
            if (this.activeName == 'course') {
                this._getList()
            } else if (this.activeName == 'ques') {
                this._getList2()
            } else if (this.activeName == 'report') {
                this._getList3()
            } else if (this.activeName == 'live') {
                this._getList4()
            }
        },
        openDialog(selectedResult) {
            selectedResult = this._.cloneDeep(selectedResult)
            this.course.tableData = []
            this.ques.tableData = []
            this.report.tableData = []
            this.dialogVisible = true
            this.selectedResult = selectedResult || []
            this._getList()
        },
        cancel() {
            this.course.tableData = []
            this.ques.tableData = []
            this.report.tableData = []
            this.course.page.page = 1
            this.ques.page.page = 1
            this.report.page.page = 1
            this.course.param.kmcname = ''
            this.ques.param.kmcname = ''
            this.report.param.kmcname = ''
            this.activeName = 'course',
            this.dialogVisible = false
        },
        handelQuery() {
            if (this.activeName == 'course') {
                this.course.page.page = 1
                this.course.tableData = []
                this._getList()
            } else if (this.activeName == 'ques') {
                this.ques.page.page = 1
                this.ques.tableData = []
                this._getList2()
            } else if (this.activeName == 'report') {
                this.report.page.page = 1
                this.report.tableData = []
                this._getList3()
            } else if (this.activeName == 'live') {
                this.live.page.page = 1
                this.live.tableData = []
                this._getList4()
            }
        },
        _getList() {
            this.setLoading(true)
            getAsseCommonformKMCList({
                data: Object.assign({}, this.course.param, this.course.page),
                success: data => {
                    data.data.content.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.course.tableData = data.data.content
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj, i) => {
                            this.course.tableData.forEach((obj2, j) => {
                                if (obj.kmcinnerid === obj2.kmcinnerid) {
                                    obj2.isCheck = true
                                    this.$refs.multipleTable1.toggleRowSelection(this.course.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.course.total = data.data.pageinfo.rowCount
                    this.course.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList2() {
            this.setLoading(true)
            getAsseCommonformKMCList({
                data: Object.assign({}, this.ques.param, this.ques.page),
                success: data => {
                    data.data.content.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.ques.tableData = data.data.content
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj, i) => {
                            this.ques.tableData.forEach((obj2, j) => {
                                if (obj.kmcinnerid === obj2.kmcinnerid) {
                                    obj2.innerid = obj.innerid
                                    obj2.isCheck = true
                                    this.$refs.multipleTable2.toggleRowSelection(this.ques.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.ques.total = data.data.pageinfo.rowCount
                    this.ques.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList3() {
            this.setLoading(true)
            getAsseCommonformKMCList({
                data: Object.assign({}, this.report.param, this.report.page),
                success: data => {
                    data.data.content.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.report.tableData = data.data.content
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj, i) => {
                            this.report.tableData.forEach((obj2, j) => {
                                if (obj.kmcinnerid === obj2.kmcinnerid) {
                                    obj2.innerid = obj.innerid
                                    obj2.isCheck = true
                                    this.$refs.multipleTable3.toggleRowSelection(this.report.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.report.total = data.data.pageinfo.rowCount
                    this.report.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList4() {
            this.setLoading(true)
            getAsseCommonformKMCList({
                data: Object.assign({}, this.live.param, this.live.page),
                success: data => {
                    data.data.content.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.live.tableData = data.data.content
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj, i) => {
                            this.report.tableData.forEach((obj2, j) => {
                                if (obj.kmcinnerid === obj2.kmcinnerid) {
                                    obj2.innerid = obj.innerid
                                    obj2.isCheck = true
                                    this.$refs.multipleTable4.toggleRowSelection(this.live.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.live.total = data.data.pageinfo.rowCount
                    this.live.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        handleAllSelectionChange(selection) {
            if (this.activeName == 'course') {
                this.course.tableData.forEach((obj, i) => {
                    this._changeSelection(obj)
                })
            } else if (this.activeName == 'ques') {
                this.ques.tableData.forEach((obj, i) => {
                    this._changeSelection(obj)
                })
            }  if (this.activeName == 'report') {
                this.report.tableData.forEach((obj, i) => {
                    this._changeSelection(obj)
                })
            }
        },
        handleSelectionChange(selection, row) {
            this.handleRowChange(row)
        },
        handleRowChange(row) {
            if (this.activeName == 'course') {
                if (!row.isCheck) {
                    this.$refs.multipleTable1.clearSelection()
                    this.$refs.multipleTable1.toggleRowSelection(row)
                } else {
                    this.$refs.multipleTable1.toggleRowSelection(row, false)
                }
            } else if (this.activeName == 'ques') {
                if (!row.isCheck) {
                    this.$refs.multipleTable2.clearSelection()
                    this.$refs.multipleTable2.toggleRowSelection(row)
                } else {
                    this.$refs.multipleTable2.toggleRowSelection(row, false)
                }
            } else if (this.activeName == 'report') {
                if (!row.isCheck) {
                    this.$refs.multipleTable3.clearSelection()
                    this.$refs.multipleTable3.toggleRowSelection(row)
                } else {
                    this.$refs.multipleTable3.toggleRowSelection(row, false)
                }
            } else if (this.activeName == 'live') {
                if (!row.isCheck) {
                    this.$refs.multipleTable4.clearSelection()
                    this.$refs.multipleTable4.toggleRowSelection(row)
                } else {
                    this.$refs.multipleTable4.toggleRowSelection(row, false)
                }
            }
            this._changeSelection(row)
        },
        _changeSelection(row) {
            row.isCheck = !row.isCheck
            if (row.isCheck) {
                let obj = {
                    innerid: '',
                    kmcinnerid: row.kmcinnerid,
                    kmcname: row.kmcname,
                    kmctype: row.kmctype,
                    kmctypename: row.kmctypename,
                    coverurl: row.coverurl
                }
                this.selectedResult = [obj]
            } else {
                this.selectedResult = []
            }
        },
        handleSure() {
            if (!this.selectedResult.length) {
                this.$message.error('请选择商品')
                return false
            }
            this.$emit('setCourseQuesList', this.selectedResult)
            this.cancel()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user', 'brandBusiness'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.courseAndQuesDialog {
    display: flex;
    .right_main_box {
        width: 100%;
    }
    .search_box {
        display: flex;
        margin-bottom: 10px;
        justify-content: space-between;
        .innerbox {
            display: flex;
            align-items: center;
        }
        .el-input {
            width: 240px;
        }
        .el-input__inner {
            height: 32px;
        }
        .el-input__icon {
            line-height: 32px;
        }
        .el-button,
        .el-button--mini {
            height: 32px;
            width: 96px;
            margin-left: 20px;
            margin-bottom: 0px;
        }
    }
    .add_goods_tabs_box {
        .el-table {
            min-height: 340px;
            .el-table__row {
                cursor: pointer;
            }
        }
        .goods_item_box {
            display: flex;
            align-items: center;
            height: 50px;
            box-sizing: border-box;
            .left {
                position: relative;
                margin-right: 12px;
                .img {
                    width: 81px;
                    height: 48px;
                }
            }
            .right{
                flex-grow: 1;
                overflow: hidden;
                .innerbox{
                    width: 100%;
                }
            }
        }
        .el-table__empty-block {
            height: 340px;
            max-height: 340px;
        }
        .el-table__empty-text {
            position: relative;
            top: 80px;
        }
    }
    .el-table::before {
        height: 0;
    }
    .el-tabs__new-tab {
        width: 100px;
        border-width: 0;
        color: #606266;
        font-size: 14px;
        &:hover {
            color: #409EFF;
        }
        .el-icon-plus:before {
            content: '';
        }
    }
    /*.course .el-tabs__new-tab:after {*/
        /*content: '邀请团长';*/
    /*}*/
    /*.ques .el-tabs__new-tab:after {*/
        /*content: '+ 提货点';*/
    /*}*/
    .el-table__body-wrapper {
        height: 350px;
        overflow-y: auto !important;
    }
   .el-table__header .el-checkbox{
       display: none;
   }
}
</style>
